/**
 * src/hooks/useProfile.js
 */
import { useDispatch, useSelector } from "react-redux";
import {
  fetchProfile,
  updatePassword,
  updateProfilePicture,
  clearPasswordState,
  clearPictureState,
  deleteProfilePicture,
} from "../store/slices/profileSlice";

const useProfile = () => {
  const dispatch = useDispatch();

  const {
    profileData,
    isFetchingProfile,
    isUpdatingPassword,
    isUploadingPicture,
    profileError,
    passwordError,
    pictureError,
    passwordSuccess,
    pictureSuccess,
     isDeletingPicture,
  } = useSelector((state) => state.profile);

   return {
    profileData,
    isFetchingProfile,
    isUpdatingPassword,
    isUploadingPicture,
    isDeletingPicture,
    profileError,
    passwordError,
    pictureError,
    passwordSuccess,
    pictureSuccess,

    loadProfile: () => dispatch(fetchProfile()),
    changePassword: (currentPassword, newPassword) =>
      dispatch(updatePassword({ currentPassword, newPassword })),
    uploadPicture: (formData) => dispatch(updateProfilePicture(formData)),
    deletePicture: () => dispatch(deleteProfilePicture()),   
    clearPasswordState: () => dispatch(clearPasswordState()),
    clearPictureState: () => dispatch(clearPictureState()),
  };
};

export default useProfile;
